{
  "title": "Instrucciones de pago",
  "body": "Configure el importe, la frecuencia y el destino de tus retiros de {{fundPrefix}} para que se adapten a sus necesidades financieras.",
  "paymentFrequency": "Frecuencia de pago:",
  "startDate": "Fecha de inicio:",
  "depositTo": "Depósito a:",
  "modal": {
    "title": "Establecer instrucciones de pago",
    "subtitle": {
      "1": "Un {{fundPrefix}} proporciona ingresos estables para la jubilación: le permite hacer retiros flexibles y graduales según la frecuencia y el monto que usted elija, siempre y cuando cumpla con los requisitos. ",
      "2": "Retiro mínimo anual ",
      "3": "importe."
    },
    "ageSelectLabel": "Seleccione la edad para calcular el retiro mínimo",
    "myAgeSelectOption": "Usar mi edad ({{age}})",
    "mySpousesAgeSelectOption": "Usar edad de mi cónyuge ({{age}})",
    "totalAnnualWithdrawalLabel": "Retiro anual total",
    "totalAnnualWithdrawalMinimumAmountOption": "Cantidad mínima permitida",
    "totalAnnualWithdrawalCustomAmountOption": "Importe personalizado",
    "totalAnnualWithdrawalMaximumAmountOption": "Cantidad máxima permitida",
    "amountLabel": "Importe",
    "paymentFrequencyLabel": "Frecuencia de pago",
    "ANNUALLY": "Anual",
    "SEMI_ANNUALLY": "Semestral",
    "QUARTERLY": "Trimestral",
    "MONTHLY": "Mensual",
    "withdrawalTypeLabel": "Tipo de retiro",
    "withdrawalTypeNetOption": "Neto",
    "withdrawalTypeGrossOption": "Bruto",
    "startDateLabel": "Fecha de inicio",
    "note1": "Las instrucciones de pago se ejecutarán según lo indicado. En cualquier momento puede cambiar sus preferencias de pago. Tenga en cuenta que todos los retiros están sujetos a impuestos como ingresos en el año en que se realizan y que los montos que superen el pago mínimo anual también estarán sujetos a retenciones fiscales.",
    "note2": "* El retiro mínimo anual es una estimación basada en la edad seleccionada y está sujeto a cambios.",
    "subAccountLabel": "Subcuenta"
  },
  "lifTitle": "fondo de ingresos vitalicios",
  "rifTitle": "fondo de ingresos para la jubilación",
  "totalAnnualWithdrawal": "Retiro anual total:",
  "amount": "Importe:",
  "invalidSubAccountToastMessage": "Se requiere una subcuenta válida en estado ACTIVO o EN ESPERA DE REVISIÓN"
}
